module.exports = __webpack_public_path__ + "21713254f874e6e234caaf6eed07c04a.svg";